
import React from "react";
import { Input, Icon, Button, Popconfirm, Popover, Tooltip, Modal, Table, Select, Row, Col, Checkbox, message } from 'antd';

import { Job, User, OutputType, ProcessType } from '../JmReact';
import PageToolbar from "./PageToolbar";
import PictureView from "./PictureView";
import TableIDs from '../data/TableIDs.js';
import InputNumeric from "./InputNumeric";
import { fixCurrentPage } from "../utils/utils";
import ResponsiveTable from "./ResponsiveTable";

import "../style/generalUI.css";
import { request } from "https";
import LangContext from "../contextProvider/LangContext";
import ReportShowButton from "./ReportShowButton.js";
import moment from "moment";

const { Option, OptGroup } = Select;
const { TextArea } = Input;

const topHeight = 200; // px
const rowHeight = 40;  // px

//type State = {}
class ModalAccumulationOfPoints extends React.Component/*<Props, State>*/ {
    // props: user,tableFormat,apiCalls
    constructor(props/*: Props*/) {
        super(props);
        this.state = {
            loading: false,
            visible: false,
        }

        this.id = "MODAL_ACCUMULATION_OF_POINTS";
        this.state = { defaultItemCode: "", itemCodeSelectionVisible: false };

        // calc page height
        this.state.height = window.innerHeight;
        this.doOnResize = null;

        if (props.data[this.id] === undefined) {
            props.data[this.id] = { ...props.data.genericData };
        }

        // if (props.data[TableIDs.genericSelectorTagRelation] === undefined) {
        //     props.data[TableIDs.genericSelectorTagRelation] = { ...props.data.genericSelector };
        // }

        this.api = {
            get: "get_deals_activity_table_list",
            // create: "create_tag_type",
            // edit: "edit_tag_type",
            // delete: "delete_tag_type",
            selector: "get_tag_relation_list", // TODO: tag type categories
            // selector_tags: "get_tag_types_with_relation_list",
        }

        this.actionButtons = [
            {
                buttonType: 'refresh',
                buttonFunction: this.refreshData
            },
            //  {
            //     buttonType: 'print',
            //     buttonFunction: () => { this.generateReport(this.props.data[this.id].filters) }
            // },
        ]

        this.modalData = []

    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidMount() {
        // document.title = "Cash On Tab - ";
        this.initFilters();
        this.props.dataActions.genericSelectorRefreshDataset(
            TableIDs.genericSelectorTagRelation, this.props.user.companyCode,
            this.props.user.token, this.api.selector);
        //this.refreshData();

        window.addEventListener("resize", () => {
            clearTimeout(this.doOnResize);
            this.doOnResize = setTimeout(this.handleWindowSizeChange, 100)
        });
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleWindowSizeChange);
    }

    handleWindowSizeChange = () => {
        if (!(/Android/i.test(navigator.userAgent)))
            this.setState({ height: window.innerHeight }, this.initFilters);
    };

    initFilters = () => {


        //console.log('xxx-yuda ',numOfRowsByHeight);
        let custData = this.props.data.CUSTOMER_POINTS_LIST.data;
        let custIndex = this.props.ui.data ? this.props.ui.data.customerIndex : -1;
        this.modalData = custData && custIndex > -1 && custData[custIndex] ? custData[custIndex].split('\f') : []

        let request = {
            _id: this.modalData[0] ? this.modalData[0] : 0,
            page: 1,
            recordsPerPage: 999999, //5,
            sortType: 1,
            sortColumn: 1,
            // api
            _page_num: 1,
            _rows_num: 999999, //5,
            _isAsc: 1,
            _sort_by: 'col_1',
            _words: '',
        };
        this.props.dataActions.genericDataSetFilter(
            this.id,
            this.props.user.companyCode,
            this.props.user.token,
            request,
            this.api.get);
    }

    refreshData = () => {
        this.props.dataActions.genericDataGetRequested(
            this.id, this.props.user.companyCode, this.props.user.token, this.api.get);
        // this.props.dataActions.genericSelectorRefreshDataset(
        //     TableIDs.genericSelectorTagRelation, this.props.user.companyCode,
        //     this.props.user.token, this.api.selector);
    }

    componentDidUpdate(prevProps) {
        if (this.props.ui.data !== prevProps.ui.data || (prevProps.toggle === false && this.props.toggle === true)) {
            this.initFilters()
        }
    }

    // handleTableChange = (pagination: Object, filters: Object, sorter: Object) => {

    //     let request = {
    //         // just of ui-pagination update

    //         page: pagination.current,
    //         recordsPerPage: pagination.pageSize,
    //         sortType: sorter.order === undefined || sorter.order === "ascend" ? 1 : 0,
    //         //
    //         _page_num: pagination.current,
    //         _rows_num: pagination.pageSize,
    //         _isAsc: sorter.order === undefined || sorter.order === "ascend" ? 1 : 0,
    //         // _sort_by: 'col_1',//+ col,
    //         _words: '',
    //     };

    //     this.props.dataActions.genericDataSetFilter(
    //         this.id, this.props.user.companyCode, this.props.user.token, request, this.api.get)
    // }
    checkIfChecked = (col: any, text: any, record: any) => {
        let checkedVal = (this.props.data[this.id].editing === record.key)
            ? this.props.data[this.id].editedRecord[col] : text;
        return (checkedVal == 1 || checkedVal === '1') ? true : false;
    }

    handleChangeCheckBox = (e: any, val: any, dataIndex: string, record: any) => {
        console.log("checkbox change: ", e.target.checked, { [dataIndex]: (e.target.checked) ? 1 : 0 });
        this.props.dataActions.genericDataSetEdit(
            this.id, { [dataIndex]: (e.target.checked) ? 1 : 0 }
        )
    }

    handleCreateNew = () => {
        this.props.dataActions.genericDataStartInlineCreate(this.id);
    }

    showModal = () => {
        this.setState({
            visible: true,
        });
    }

    handleOkLeave = () => {
        //this.clear();
        this.props.uiActions.hideModal(TableIDs.modalCreatePriceList);
    }
    handleOk = () => {
        //this.clear();
    }
    handleCancel = () => {
        this.setState({ visible: false });
        //this.clear();
        this.props.uiActions.hideModal(TableIDs.modalCreatePriceList);
    }

    // generateReport(filters) {
    //     let params = {
    //         _id: filters._id,
    //         _words: encodeURIComponent(filters._words),
    //         _page_num: 1,
    //         _rows_num: 999999,
    //         _isAsc: 1,
    //         reportName: "reports/CustomerPointsDetails.pdf",
    //         REPORT_LOCALE: this.getText(101),
    //     }
    //     this.props.ActionQueue.addToQueue({
    //         action: this.props.dataActions.generateReport,
    //         args: [this.props.user.companyCode, this.props.user.token, params]
    //     });

    // }

    generateReport = (filters, reportName) => {
        let params = {
            _id: filters._id,
            _words: encodeURIComponent(filters._words),
            _page_num: 1,
            _rows_num: 999999,
            _isAsc: 1,
            reportName: "reports/" + reportName,
            REPORT_LOCALE: this.getText(101),
        }
        this.props.ActionQueue.addToQueue({
            action: this.props.dataActions.generateReport,
            args: [this.props.user.companyCode, this.props.user.token, params]
        });

    }

    reportButton = () => {
        let subButton = (text, type, reportName) => {
            let onClick = () => { this.generateReport(this.props.data[this.id].filters, reportName) }
            return (
                <Tooltip title={this.getText(text)}>
                    <Icon style={{ fontSize: 32 }} className={"clickable margin-4"} type={type} onClick={onClick} />
                </Tooltip>)
        }

        let content = (<div>
            {subButton(12721, "file-pdf", "CustomerPointsDetails.pdf")}
            {subButton(12722, "file-excel", "CustomerPointsDetailsExcel.xls")}
        </div>);

        return (
            <Tooltip title={this.getText(12720)}>
                <Popover content={content} title={this.getText(12723)} trigger="click">
                    <Button key={"report-print"} className={"btn"} style={{ marginTop: "5px", marginLeft: "5px" }}>
                        <Icon style={{ fontSize: 16 }} type={"printer"} theme="outlined" />
                    </Button>
                </Popover>
            </Tooltip >)
    }

    render() {
        const { loading } = this.state;

        let modalTitleStyle = { padding: '4px', paddingLeft: '40px' }
        let space = window.innerWidth > 600 ? ' ' : (<br />)

        let modalTitle = (<span>
            <span style={modalTitleStyle}>{this.getText(10960)}</span>{space}
            <span style={modalTitleStyle}>{this.getText(10961)}: {this.modalData[1]}</span>{space}
            <span style={modalTitleStyle}>{this.getText(10962)}: {this.modalData[2]}</span>{space}
            <span style={modalTitleStyle}>{this.getText(10963)}: {this.modalData[5]}</span>
            <br />
            <span style={modalTitleStyle}></span>{space}
            <span style={modalTitleStyle}>{this.getText(22374)}: {this.modalData[7]} {this.modalData[8]}</span>{space}

            {this.modalData[10] ? <span style={modalTitleStyle}>{this.getText(22375)}: {this.modalData[10]} {this.modalData[11]}</span> : ""}{space}
        </span>
        );

        let titleBar = (
            <div style={{
                paddingLeft: '4px',
                paddingRight: '4px',
                paddingTop: '4px',
                paddingBottom: '4px',
            }}>
                <PageToolbar
                    height={70}
                    title={modalTitle}
                    actionButtons={this.actionButtons}
                    genericActionButtons={[this.reportButton()]}
                    isModal={true}
                    ui={this.props.ui}
                    uiActions={this.props.uiActions}
                    data={this.props.data}
                    dataActions={this.props.dataActions}
                />
            </div>)

        let columns =
            [
                {
                    title: this.getText(10964),
                    dataIndex: "dId",
                    key: "dId",
                    sorter: false,
                    width: '10%',
                    render: (text, record) => text,
                }, {
                    title: this.getText(10965),
                    dataIndex: "dDate",
                    key: "dDate",
                    width: '10%',
                    sorter: false,
                    render: (text, record) => moment(text).format('DD/MM/YYYY'),
                }, {
                    title: this.getText(10966),
                    dataIndex: "dTime",
                    key: "dTime",
                    width: '10%',
                    sorter: false,
                    render: (text, record) => text,
                }, {
                    title: this.getText(10967),
                    dataIndex: "dType",
                    key: "dType",
                    width: '8%',
                    sorter: false,
                    render: (text, record) => text,
                }, {
                    title: this.getText(16071),
                    dataIndex: "dBranch",
                    key: "dBranch",
                    width: '13%',
                    sorter: false,
                    render: (text, record) => text,
                }, {
                    title: this.getText(10968),
                    dataIndex: "dDocNum",
                    key: "dDocNum",
                    width: '10%',
                    sorter: false,
                    render: (text, record) => text,
                }, {
                    title: this.getText(10969),
                    dataIndex: "dSumPoints",
                    key: "dSumPoints",
                    width: '11%',
                    sorter: false,
                    render: (text, record) => parseFloat(text) > 0 ? text : '',
                }, {
                    title: this.getText(10970),
                    dataIndex: "dSumPoints",
                    key: "dUsePoints",
                    width: '11%',
                    sorter: false,
                    render: (text, record) => parseFloat(text) <= 0 ? text * -1 : '',
                }, {
                    title: this.getText(21255),
                    dataIndex: "dBalance",
                    key: "dBalance",
                    width: '11%',
                    sorter: false,
                    render: (text, record) => text ? parseFloat(text).toFixed(2) : '0.00',
                }, {
                    title: "",
                    width: '6%',
                    render: (text, record) => {
                        if (!record['dDocNum'] || !record['dType'] || !record['dPos']) return ""
                        return (<ReportShowButton
                            {...this.props}
                            iconButton
                            validSubmit
                            params={{
                                DocumentNumber: record['dDocNum'],
                                DocumentTypeID: record['dType'],
                                DocumentPOSID: record['dPos'],
                                userID: this.props.user.userId,
                                userName: encodeURIComponent(this.props.user.displayName),
                                docIsWithSigns: "0",
                                reportName: "reports/DocumentCopy.pdf"
                            }} />)
                    },
                }
            ];

        let numOfRowsByHeight = parseInt((this.state.height - topHeight > rowHeight)
            ? (this.state.height - topHeight) / rowHeight
            : 1);

        let dBalance = 0;

        const dataSource = this.props.data[this.id].data.map((x, index) => {
            let y = x.split("\f")
            dBalance = dBalance + parseFloat(y[5])
            return {
                key: y[0],
                index,
                dBalance,

                dId: y[0],
                dDate: y[1],
                dTime: y[2],
                dType: y[3],
                dDocNum: y[4],
                dSumPoints: y[5],
                dUseSubscribers: y[6],
                dCust: y[7],
                dCustName: y[8],
                dDealName: y[9],
                dDealDate: y[10],
                dBranch: y[11],
                dPos: y[12],
            }
        })

        return (
            <Modal
                //style={modalStyle}
                destroyOnClose={true}
                width={'90%'}
                visible={false || this.props.toggle}
                // title={this.props.title} // pass title in props for generics
                title={titleBar}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                footer={false}
                ui={this.props.ui} uiActions={this.props.uiActions}
                data={this.props.data} dataAction={this.props.dataAction}
            >

                <ResponsiveTable
                    columns={columns}
                    dataSource={dataSource}
                    bordered
                    // pagination={this.props.data[this.id].pagination}
                    // onChange={this.handleTableChange}
                    pagination={{ pageSize: numOfRowsByHeight }}
                    tableOnly={true}
                    ui={this.props.ui}
                    uiActions={this.props.uiActions}
                    percentageToMobile={[false, 30, 35, false, false, 35]}
                />
            </Modal >
        )
    }
}

export default ModalAccumulationOfPoints;
